import { render, staticRenderFns } from "./AdzoneEdit.vue?vue&type=template&id=5899bed0&scoped=true"
import script from "./AdzoneEdit.vue?vue&type=script&lang=js"
export * from "./AdzoneEdit.vue?vue&type=script&lang=js"
import style0 from "./AdzoneEdit.vue?vue&type=style&index=0&id=5899bed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899bed0",
  null
  
)

export default component.exports